import { create } from "zustand";

/** Discriminated union of the issues the backend reports inside
 *  ``code: table_constraints_override_required``. The dialog renders
 *  per-kind copy so the operator sees exactly what trips before
 *  confirming. */
export type TableConstraintsIssue =
  | {
      kind: "wasteful";
      pax: number;
      total_min: number;
      total_max: number;
    }
  | {
      kind: "too_small";
      pax: number;
      total_min: number;
      total_max: number;
    }
  | {
      kind: "too_big";
      pax: number;
      total_min: number;
      total_max: number;
    }
  | {
      kind: "missing_features";
      required: string[];
      missing_by_table: Record<string, string[]>;
    }
  | {
      kind: "out_of_preferred_zone";
      preferred_zone_id: string | null;
      preferred_zone_name: string;
      out_of_zone_table_names: string[];
    };

export interface TableConstraintsContext {
  issues: TableConstraintsIssue[];
}

interface Pending {
  context: TableConstraintsContext;
  resolve: (acknowledge: boolean) => void;
}

interface State {
  pending: Pending | null;
  open: (context: TableConstraintsContext) => Promise<boolean>;
  close: (acknowledge: boolean) => void;
}

export const useTableConstraintsOverrideStore = create<State>((set, get) => ({
  pending: null,
  open: (context) =>
    new Promise<boolean>((resolve) => {
      set({ pending: { context, resolve } });
    }),
  close: (acknowledge) => {
    const { pending } = get();
    if (pending) {
      pending.resolve(acknowledge);
      set({ pending: null });
    }
  },
}));
